import { Component, Input } from '@angular/core';
import { ReferralMatchVerification } from '../../../core/models/referral-match-verification.model';
import { DatePipe } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { JoinListPipe } from '../../../shared/pipes/join-list.pipe';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';
import { ReferralVerificationReasonShortNamesPipe } from '../../../shared/pipes/referral-verification-reason-short-names.pipe';

@Component({
    selector: 'app-validate-referral-match-verifications-client-list',
    templateUrl: './validate-referral-match-verifications-client-list.component.html',
    styleUrls: ['./validate-referral-match-verifications-client-list.component.scss'],
    imports: [FaIconComponent,
              DatePipe,
              JoinListPipe,
              BlankValueDashPipe,
              ReferralVerificationReasonShortNamesPipe]
})
export class ValidateReferralMatchVerificationsClientListComponent {
  @Input() patientReferralMatchVerifications: ReferralMatchVerification[];
}
